import { AxiosStatic } from 'axios';

import { usePhoneCallStore } from 'src/stores/phoneCall';

import { AbstractPhoneCallGatewayWithHangupFunctionalityStrategy } from 'src/components/phoneCall/phoneCallGateway/AbstractPhoneCallGatewayWithHangupFunctionalityStrategy';
import { DirectPhoneCallGatewayWithHangupFunctionalityStrategy } from 'src/components/phoneCall/phoneCallGateway/DirectPhoneCallGatewayWithHangupFunctionalityStrategy';
import { sendGenericPostRequest } from 'src/components/phoneCall/phoneCallGateway/genericPostRequest/sendGenericPostRequest';

import { OutgoingCallConfigurationForTheUser } from 'src/models/phoneCall';

import { CommandBus } from 'src/util/command/CommandBus';

type PhoneCallStore = ReturnType<typeof usePhoneCallStore>;

export class GenericPostDirectPhoneCallGatewayWithHangupFunctionalityStrategy
	extends AbstractPhoneCallGatewayWithHangupFunctionalityStrategy
	implements DirectPhoneCallGatewayWithHangupFunctionalityStrategy
{
	private readonly axios: AxiosStatic;
	private readonly outGoingCallConfigurationForTheUser: OutgoingCallConfigurationForTheUser;

	constructor(
		axios: AxiosStatic,
		phoneCallStore: PhoneCallStore,
		commandBus: CommandBus,
		authenticatedUserId: number,
		outGoingCallConfigurationForTheUser: OutgoingCallConfigurationForTheUser
	) {
		super(phoneCallStore, commandBus, authenticatedUserId);
		this.axios = axios;
		this.outGoingCallConfigurationForTheUser = outGoingCallConfigurationForTheUser;
	}

	public async makeCall(callerName: string, toNumber: string): Promise<string> {
		await sendGenericPostRequest(this.axios, this.outGoingCallConfigurationForTheUser.url_init as string, {
			number: toNumber,
			terminal: this.outGoingCallConfigurationForTheUser.terminal,
		});

		this.setActiveCallId(this.outGoingCallConfigurationForTheUser.terminal);
		return await this.createPhoneCall(callerName, toNumber);
	}

	public endCall(): void {
		sendGenericPostRequest(this.axios, this.outGoingCallConfigurationForTheUser.url_hangup as string, {
			terminal: this.outGoingCallConfigurationForTheUser.terminal,
		}).catch(() => {
			/* empty */
		});

		this.clearActiveCall();
	}
}
